import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
import { TableLayout } from "../../../components"
import { LoadModal } from "../../modais"
import { ToastContainer, ToastMessage } from "react-toastr"
import Truncate from "react-truncate"
import { confirmAlert } from "react-confirm-alert"
class TableTermoCircunstanciado extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
    this.getTermoCircunstanciado = this.getTermoCircunstanciado.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteTermo(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  getTermoCircunstanciado(event, id) {
    this.toggleLoadModal()
    ApiHelper.printTermoCircunstanciado(id, (ficha, error) => {
      this.toggleLoadModal()
      if (ficha) {
        var url = URL.createObjectURL(ficha)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Termo cirscunstaciado - " + id + ".pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  render() {
    var buttons = [
      {
        title: "Criar termo circunstanciado",
        link: "/termocircunstanciado/create",
        icon: "control_point"
      },
      {
        title: "Termso circunstanciados deletados",
        link: "/termocircunstanciado/trash",
        icon: "delete"
      }
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar termo circunstanciado"
        >
          {this.props.rows.map((row, key) => {
            return (
              <div key={key} className="col-md-4">
                <div className="card">
                  <div
                    className="card-header"
                    data-background-color={this.props.backgroundColor}
                  >
                    <h4 className="title text-center col-md-offset-right-1">
                      {"Contrato Nº " + row.contrato.num_contrato}
                    </h4>
                    <p className="category text-center col-md-offset-right-1">
                      {"Criado em " + Moment(row.created_at).format("D/MM/Y")}
                    </p>
                  </div>
                  <div className="termo-quote col-md-12">
                    <div className="card">
                      <div
                        className="card-header"
                        style={{ padding: 0 }}
                        data-background-color={this.props.backgroundColor}
                      >
                        <h5 className="title text-center">Parecer</h5>
                      </div>
                      <div className="card-content">
                        <Truncate
                          lines={1}
                          ellipsis={<span className="label-quote">...</span>}
                        >
                          {row.parecer}
                        </Truncate>
                      </div>
                    </div>
                    <div className="card">
                      <div
                        className="card-header"
                        style={{ padding: 0 }}
                        data-background-color={this.props.backgroundColor}
                      >
                        <h5 className="title text-center">Ressalva</h5>
                      </div>
                      <div className="card-content">
                        <Truncate
                          lines={1}
                          ellipsis={<span className="label-quote">...</span>}
                        >
                          {row.ressalva}
                        </Truncate>
                      </div>
                    </div>
                    <div className="col-md-7 col-md-offset-3">
                      <Link
                        title="Editar termo circunstanciado"
                        className="btn btn-primary btn-simple btn-xs"
                        to={"termocircunstanciado/edit/" + row.id}
                      >
                        <i className="material-icons">edit</i>
                      </Link>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover termo circunstanciado"
                        onClick={() => this.delete(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                      <button
                        type="button"
                        onClick={event =>
                          this.getTermoCircunstanciado(event, row.id)
                        }
                        rel="tooltip"
                        title="Imprimir termo circunstanciado"
                        className="btn btn-info btn-simple btn-xs"
                      >
                        <i className="material-icons">print</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableTermoCircunstanciado)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/termo-circunstanciado/TableTermoCircunstanciado.js